import { useActiveSenderIds } from 'hooks/useActiveSenderId'
import useDefaultGreeting from 'hooks/useDefaultGreeting'
import usePrevious from 'hooks/usePrevious'
import useTrackImpressionOnce from 'hooks/useTrackImpressionOnce'
import { triggerAwayMessageAPIEvent, triggerWelcomeMessageAPIEvent } from 'modules/api/events'
import { isNil } from 'ramda'
import React, { LegacyRef, useEffect } from 'react'
import { useSelector } from 'react-redux'

import SenderInfo from '../SenderInfo'

import './style.css'

interface GreetingMessageProps {
  previewRef: LegacyRef<HTMLParagraphElement>
}

const GreetingMessage = ({ previewRef }: GreetingMessageProps) => {
  const defaultGreeting = useDefaultGreeting()
  const senderIds = useActiveSenderIds()
  const { chatOpen } = useSelector(state => state.view)
  const prevChatOpen = usePrevious(chatOpen)
  const matchedHours = useSelector(state => state.view.matchedHours)

  useTrackImpressionOnce()

  useEffect(() => {
    if (!isNil(prevChatOpen) && chatOpen !== prevChatOpen) {
      if (!!matchedHours) {
        triggerWelcomeMessageAPIEvent(chatOpen)
      } else {
        triggerAwayMessageAPIEvent(chatOpen)
      }
    }
  }, [prevChatOpen, chatOpen, matchedHours])

  return (
    <div className="drift-widget-greeting">
      <SenderInfo senderIds={senderIds}/>
      <p ref={previewRef} className="drift-widget-greeting-content">
        { defaultGreeting }
      </p>
    </div>
  )
}


export default GreetingMessage
